<template>
  <div class="payrollList">
    <div class="searchTop" v-if="position">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          {{ $t.payrollList.position }} : {{ position }}
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="firstLoad(1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">{{ $t.payrollList.type }}</div>
        <div class="list-item">
          {{ $t.payrollList.paymentRecordNumber }}：{{ item.OperationRecordNumber }}
        </div>
        <div class="list-item">{{ $t.payrollList.applicant }}：{{ item.UserName }}</div>
        <div class="list-item">
          {{ $t.payrollList.department }}：{{ item.Department }}
        </div>
        <div class="list-item">
          {{ $t.payrollList.submitTime }}：{{ item.SubmitTime }}
        </div>
        <div class="list-item">
          {{ $t.payrollList.submitCount }}：{{ item.SubmitCount }}
        </div>
        <div class="list-item">{{ $t.payrollList.currency }}：{{ item.CurrencySn }}</div>
        <div class="list-item">{{ $t.payrollList.costAmount }}：{{ item.FeeAmount }}</div>
        <div class="list-item">
          {{ $t.payrollList.menthodState }}：
          <span v-if="item.PaymentMethod == 1">{{ $t.payrollList.mState1 }}</span>
          <span v-if="item.PaymentMethod == 2">{{ $t.payrollList.mState2 }}</span>
          <span v-if="item.PaymentMethod == 3">{{ $t.payrollList.mState3 }}</span>
        </div>
        <div class="list-item">
          {{ $t.payrollList.approvalState }}：
          <span v-if="item.ApprovalState == 0">{{ $t.payrollList.aState1 }}</span>
          <span v-if="item.ApprovalState == 1">{{ $t.payrollList.aState2 }}</span>
          <span v-if="item.ApprovalState == 2">{{ $t.payrollList.aState3 }}</span>
          <span v-if="item.ApprovalState == 3">{{ $t.payrollList.aState4 }}</span>
          <span v-if="item.ApprovalState == 4">{{ $t.payrollList.aState5 }}</span>
        </div>
        <div class="list-item">
          {{ $t.payrollList.paymentState }}：
          <span v-if="item.PaymentState == 0">{{ $t.payrollList.pState1 }}</span>
          <span v-if="item.PaymentState == 1">{{ $t.payrollList.pState2 }}</span>
        </div>
        <div class="list-item">
          {{ $t.payrollList.systemCode }}：{{ item.PaymentSystemCode }}
        </div>
        <div class="list-item">
          {{ $t.payrollList.totalBatch }}：{{ item.TotalBatch }}
        </div>
        <div class="list-item">
          {{ $t.payrollList.uploadDate }}：{{ item.PaymentVoucherUploadDate }}
        </div>
        <div class="buttons">
          <van-button
            class="warning-btn"
            size="small"
            type="primary"
            v-if="item.TodoList == 1"
            @click="toPayrollRequest(item)"
            >{{ $t.payrollList.button1 }}</van-button
          >

          <van-button
            class="danger-btn"
            size="small"
            type="primary"
            v-if="item.TodoList == 2"
            @click="toPayrollPayment(item)"
            >{{ $t.payrollList.button2 }}</van-button
          >

          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            v-if="item.UserId == UserId"
            @click="gotoDetail(item)"
            >{{ $t.payrollList.button3 }}</van-button
          >

          <van-button
            class="search-btn"
            size="small"
            type="primary"
            @click="gotoFinancialRequestDetail(item)"
          >
            {{ $t.payrollList.button4 }}
          </van-button>
        </div>
      </div>
    </van-list>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoDetail(null)">{{
        $t.payrollList.button5
      }}</van-button>
    </div>
  </div>
</template>

<script>
import { List, Row, Col, Button, Form, Field } from "vant";

import Vue from "vue";
Vue.use(List).use(Row).use(Col).use(Button).use(Form).use(Field);

export default {
  name: "payrollList",
  data() {
    return {
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //审核
      approvalLevel: 0,
      position: "",
      //filter
      approvalState: "0",
      paymentState: "",
    };
  },
  created() {},
  methods: {
    firstLoad(page) {
      this.loadMyWorkbench().then((success) => {
        if (success) this.getList(page);
      });
    },
    toPayrollRequest(item) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "payrollRequest",
        name: "payrollRequest",
        query: [
          {
            name: "OERId",
            value: item.OERId,
          },
          {
            name: "Type",
            value: "detail",
          },
        ],
      });
    },
    gotoFinancialRequestDetail(item) {
      var data = item;
      data.PaymentType = 2;
      localStorage.setItem("financialRequestDetail", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "financialRequestDetail",
        name: "financialRequestDetail",
        query: [
          {
            name: "IsView",
            value: true,
          },
        ],
      });
    },
    toPayrollPayment(item) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "payrollPayment",
        name: "payrollPayment",
        query: [
          {
            name: "OERId",
            value: item.OERId,
          },
          {
            name: "Type",
            value: 2,
          },
        ],
      });
    },
    gotoDetail(item) {
      if (item) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: true,
          path: "payrollRequest",
          name: "payrollRequest",
          query: [
            {
              name: "OERId",
              value: item.OERId,
            },
            {
              name: "Type",
              value: item.UserId == this.UserId ? "edit" : "detail",
            },
          ],
        });
      } else {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: true,
          path: "payrollRequest",
          name: "payrollRequest",
          query: [
            {
              name: "Type",
              value: "new",
            },
          ],
        });
      }
    },
    loadMyWorkbench() {
      return new Promise((resolve) => {
        var param = {
          UserId: this.UserId,
        };
        this.$api.myHome
          .loadMyWorkbench(param)
          .then((res) => {
            this.approvalLevel = res.data.ApprovalLevel;
            this.position = res.data.Position;
            if (this.approvalLevel == 99) {
              this.approvalState = "4";
              this.paymentState = "0";
            }
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        PaymentType: 2,
        ApprovalState: this.approvalState,
        PaymentState: this.paymentState,
      };
      var request = null;
      if (this.approvalLevel > 0) {
        request = this.$api.financialManagement.getFinancialAuditList(param);
      } else {
        request = this.$api.financialManagement.getFinancialRequestList(param);
      }
      request
        .then((res) => {
          var data = res.data.dataPage;
          if (this.approvalLevel > 0) {
            this.tableData = this.tableData.concat(data.Data);
          } else {
            this.tableData = this.tableData.concat(res.data.Data);
          }
          this.loading = false;
          this.error = false;
          this.errorText = "";

          if (data) {
            this.page = data.PageIndexs;
            this.finished = this.page >= data.ALLPages;
          } else {
            this.page = res.meta.page;
            this.finished = this.page >= res.meta.lastPage;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.payrollList {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 100%;
        text-align: center;
        font-size: 15px;
        padding: 14px;
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .warning-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: #ffba00;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
